import styled from '@emotion/styled';
import { TextProps, Text } from '@mantine/core';

export const EllipsisText = styled(Text)<TextProps>(() => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}));
